// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeylX2 {
  display: flex;
  align-items: start;
  border-radius: 3px;
  padding: 12px 16px;
  font-size: 14px;
  font-family: inherit;
  margin: 8px 0;
  max-width: 100%;
  box-sizing: border-box;
}

.cplz9z {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
}

.uZQMuN {
  position: fixed;
  top: 50px;
  z-index: 9999;
  background: #fff;
  border: 1px solid #e0e0e0;
  align-items: center !important;
  min-width: min(792px, calc(100vw - 48px));
  max-width: calc(100vw - 48px);
}

.qFzcQ8 {
  right: var(--spacing-3);
  left: auto;
}

.P1geTK {
  left: var(--spacing-3);
  right: auto;
}

.eCzsJ2 {
  color: var(--text-neutral-dark, #1f1f1f);
  background: #edf6ff;
  border: 1px solid var(--status-info, #1573d3);
}

.Bqn0QQ {
  color: var(--text-neutral-dark, #1f1f1f);
  background: #eaffe5;
  border: 1px solid var(--status-success, #387c2b);
}

.AeJpVY {
  color: var(--text-neutral-dark, #1f1f1f);
  background: #fff8e5;
  border: 1px solid var(--secondary-yellow-600, #cb8401);
}

.iCTeYT {
  color: var(--text-neutral-dark, #1f1f1f);
  border: 1px solid var(--status-error, #dc0a0a);
  background: var(--secondary-red-200, #fee7e7);
}

.ZU4S10 {
  color: var(--text-neutral-dark, #1f1f1f);
  background: #ededed;
  border: 1px solid var(--text-neutral-stronger, #666666);
}

.j6rITh {
  padding: 8px 12px;
  font-size: 13px;
}

.kFzLAi {
  padding: 16px 20px;
  font-size: 15px;
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--radius-s);
  gap: var(--spacing-1);
  font-family: var(--font-family-base);
}

.L_w2VW {
  margin-top: 8px;
  margin-right: 8px;
  font-size: 20px;
}

.uZQMuN .L_w2VW {
  margin-top: 0;
}

.l_Niz_ {
  flex: 1;

  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 14px);
  color: var(--text-neutral-dark, #1f1f1f);
  letter-spacing: 0px;
}

.f86wqY {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.YLEVqt {
  font-size: 16px;
  color: #333;
}

.TFA25K {
  align-items: start;
}

.rKXgOc {
  align-items: center;
}

.rKXgOc .L_w2VW {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Alert/Alert.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;EAC9B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;;EAEP,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".alert {\n  display: flex;\n  align-items: start;\n  border-radius: 3px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-family: inherit;\n  margin: 8px 0;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.inline {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n}\n\n.toast {\n  position: fixed;\n  top: 50px;\n  z-index: 9999;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  align-items: center !important;\n  min-width: min(792px, calc(100vw - 48px));\n  max-width: calc(100vw - 48px);\n}\n\n.positionright {\n  right: var(--spacing-3);\n  left: auto;\n}\n\n.positionleft {\n  left: var(--spacing-3);\n  right: auto;\n}\n\n.info {\n  color: var(--text-neutral-dark, #1f1f1f);\n  background: #edf6ff;\n  border: 1px solid var(--status-info, #1573d3);\n}\n\n.success {\n  color: var(--text-neutral-dark, #1f1f1f);\n  background: #eaffe5;\n  border: 1px solid var(--status-success, #387c2b);\n}\n\n.warning {\n  color: var(--text-neutral-dark, #1f1f1f);\n  background: #fff8e5;\n  border: 1px solid var(--secondary-yellow-600, #cb8401);\n}\n\n.error {\n  color: var(--text-neutral-dark, #1f1f1f);\n  border: 1px solid var(--status-error, #dc0a0a);\n  background: var(--secondary-red-200, #fee7e7);\n}\n\n.neutral {\n  color: var(--text-neutral-dark, #1f1f1f);\n  background: #ededed;\n  border: 1px solid var(--text-neutral-stronger, #666666);\n}\n\n.compact {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.standard {\n  padding: 16px 20px;\n  font-size: 15px;\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  gap: var(--spacing-1);\n  font-family: var(--font-family-base);\n}\n\n.alertIcon {\n  margin-top: 8px;\n  margin-right: 8px;\n  font-size: 20px;\n}\n\n.toast .alertIcon {\n  margin-top: 0;\n}\n\n.alertText {\n  flex: 1;\n\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  letter-spacing: 0px;\n}\n\n.alertClose {\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-left: 8px;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n}\n\n.alertCloseIcon {\n  font-size: 16px;\n  color: #333;\n}\n\n.alignitemsstandard {\n  align-items: start;\n}\n\n.alignitemscenter {\n  align-items: center;\n}\n\n.alignitemscenter .alertIcon {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `TeylX2`,
	"inline": `cplz9z`,
	"toast": `uZQMuN`,
	"positionright": `qFzcQ8`,
	"positionleft": `P1geTK`,
	"info": `eCzsJ2`,
	"success": `Bqn0QQ`,
	"warning": `AeJpVY`,
	"error": `iCTeYT`,
	"neutral": `ZU4S10`,
	"compact": `j6rITh`,
	"standard": `kFzLAi`,
	"alertIcon": `L_w2VW`,
	"alertText": `l_Niz_`,
	"alertClose": `f86wqY`,
	"alertCloseIcon": `YLEVqt`,
	"alignitemsstandard": `TFA25K`,
	"alignitemscenter": `rKXgOc`
};
module.exports = ___CSS_LOADER_EXPORT___;
